import {
    Document,
    PDFViewer,
    Page as PDFPage,
    StyleSheet,
    Text as PDFText,
    View as PDFView,
    Image as PDFImage,

} from '@react-pdf/renderer';
import { dateFormatter } from '../../../../../utils';
const styles = StyleSheet.create({
    page: {
        padding: 20
    },
    heading: {
        fontSize: 18,
        textAlign: 'center',
        marginBottom: 20
    },
    line: {
        height: 0.6,
        backgroundColor: 'black',
        marginVertical: 10,
        marginTop: '40px'
    },
    line2: {
        height: 0.4,
        backgroundColor: 'black',
        marginVertical: 10
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 0,
        marginBottom: 0,
        border: '1px Solid black',
        padding: '10px'
    },
    contentContainer2: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 10,
        marginBottom: 0
    },
    column: {
        flex: 1,
        paddingHorizontal: 10
    },
    row: {
        flexDirection: 'row',
        marginBottom: 5
    },
    text: {
        fontSize: 9,
        display: 'inline-block'
    },
    textBold: {
        fontSize: 9,
        fontWeight: 'bold'
    },
    textUnderlined: {
        textDecoration: 'underline'
    },
    table: {
        display: 'table',
        width: 'auto',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        marginTop: 5
    },
    tableRow: {
        flexDirection: 'row'
    },
    tableColHeader: {
        width: '14.28%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        backgroundColor: '#f0f0f0',
        padding: 5
    },
    tableCol: {
        width: '13.28%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#bfbfbf',
        padding: 5
    },
    tableCellHeader: {
        fontSize: 10,
        fontWeight: 'bold'
    },
    columnHeader: {
        width: '15%',
        backgroundColor: 'navy',
        color: 'white',
        padding: 5,
        textAlign: 'center',
        marginTop: "2%"
    },
    tableCell: {
        fontSize: 10
    },
    columnContent: {
        width: '15%',
        padding: 6,
        textAlign: 'center',
        alignItems: 'center'
    }
});

const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
    <PDFPage style={{ ...styles.page, ...style }} {...props}>
        {children}
    </PDFPage>
);

const View = ({ style, children, ...props }) => (
    <PDFView style={{ ...style }} {...props}>
        {children}
    </PDFView>
);

const Text = ({ style, content, ...props }) => (
    <PDFText style={{ ...styles.text, ...style }} {...props}>
        {content}
    </PDFText>
);

export const PaymentRefundVocuherPdf = ({ data }) => {
    console.log(data);
    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }
    return (
        <PDFViewer width="100%" height="100%" showToolbar>
            <Document title={`Payment Refund Voucher`}>
                <Page size="A4" style={styles.page}>
                    <PDFImage
                        src="/logo_Hospital_m.jpeg"
                        style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
                    />
                    <View style={styles.row}>
                        <Text content="Payment Refund Voucher" style={{ fontSize: '12px', margin: '0 auto' }} />
                    </View>
                    <View style={styles.contentContainer}>
                        <View style={styles.column}>
                            <View style={styles.row}>
                                <Text content="Reciept Voucher     :   " style={styles.textBold} />
                                <Text content={`${data.doc_no
                                    }`} />
                            </View>
                            <View style={styles.row}>
                                <Text content="UHID NO./IPD No  :   " style={styles.textBold} />
                                <Text content={`${data.uhid}/${data.ipd_no}`} />
                            </View>
                            <View style={styles.row}>
                                <Text content="Date/Time              :  " />
                                <Text content={`${formatDate(data.date)} ${data?.time}`} />
                            </View>
                            <View style={styles.row}>
                                <Text content="Address                 :  " />
                                <Text content={`${data.address}`} />
                            </View>
                        </View>
                        <View style={styles.column}>
                            <View style={styles.row}>
                                <Text content="Patient Name      :  " />
                                <Text content={`${data.patientName}`} />
                            </View>
                            <View style={styles.row}>
                                <Text content="Age/Sex              :  " />
                                <Text content={`${data.age} / ${data.gender}`} />
                            </View>
                            <View style={styles.row}>
                                <Text content="Mobile                 :  " />
                                <Text content={`${data.mobile}`} />
                            </View>
                            <View style={styles.row}>
                                <Text content="Receipt Mode     :  " />
                                <Text content={`${data.payment_mode}`} />
                            </View>
                        </View>
                        <View style={styles.column}>
                            <View style={styles.row}>
                                <Text content="Department             :   " />
                                <Text content={`${data.department}`} />
                            </View>
                            <View style={styles.row}>
                                <Text content="Sponsor                   :  " />
                                <Text content={`${data.sponsor}`} />
                            </View>
                            <View style={styles.row}>
                                <Text content="Operating Doctor     :  " />
                                <Text content={`${data.doctor}`} />
                            </View>
                            <View style={styles.row}>
                                <Text content="Receipt Date            :  " />
                                <Text content={`${formatDate(data.date)} ${data?.time}`} />
                            </View>
                        </View>
                    </View>
                    <View style={styles.row}>
                        <Text style={{ ...styles.columnHeader, width: "50%" }} content="Particulars" />
                        <Text style={{ ...styles.columnHeader, width: "50%" }} content="Amount In INR" />
                    </View>


                    <View style={{ ...styles.row, }}>
                        <Text style={{ ...styles.columnContent, width: '50%' }} content="IPD Refund" />
                        <Text style={{ ...styles.columnContent, width: '50%' }} content={data.amount} />
                    </View>
                    <View style={{ ...styles.row, borderTop: "1px solid black", }}>
                        <Text style={{ ...styles.columnContent, width: '20%', marginLeft: "30%" }} content="Total Amount Refund" />
                        <Text style={{ ...styles.columnContent, width: '50%' }} content={data.amount} />
                    </View>
                </Page>
            </Document>
        </PDFViewer>
    );
};
